import { useDebounce } from '@/hooks';
import { SelectProps } from 'antd';
import { useState } from 'react';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import {
  useRecommendation,
  useRecommendations,
} from '@/core/domain/people/Recommendation/Recommendation.hooks';
import { RecommendationListQuery } from '@/core/domain/people/Recommendation/Recommendation.types';
import useSelectOptions from '@/hooks/useSelectOptions';

type Props = SelectProps & {
  queryFilter?: RecommendationListQuery;
  queryEnable?: boolean;
};

const RecommendationSelect: React.FC<Props> = ({
  queryFilter,
  queryEnable = false,
  ...props
}) => {
  const [selectClicked, setSelectClicked] = useState<boolean>(queryEnable);
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const recommendationList = useRecommendations(
    {
      active: true,
      description: search,
      rows: 10,
      ...queryFilter,
    },
    (queryEnable || selectClicked) && !props.disabled,
  );

  const recommendationDetail = useRecommendation();

  const recommendationOptions = useSelectOptions({
    list: recommendationList,
    detail: recommendationDetail,
    selectProps: props,
    labelFormatter: (recomendation) => recomendation.description,
  });

  return (
    <InfiniteSelect
      fetchNextPage={recommendationList.fetchNextPage}
      hasNextPage={recommendationList.hasNextPage}
      loading={recommendationList.isFetching}
      options={recommendationOptions}
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      showSearch
      allowClear
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
    />
  );
};

export default RecommendationSelect;
